export enum RecomendationType {
  TotalRejection,
  PartialRejection,
  LocalRework,
  Approval
}